import React, {Fragment} from "react";
import MoneyTransferList from "../../lists/MoneyTransferList";
import {postData} from "../../../../utils/request";
import {calcClassName, isFalse} from "../../../../utils/other";
import {saveComponent} from "../../../../utils/components";
import ContentLoader from "../../../layout/ContentLoader";
import ComponentConfig from "../../../form/ComponentConfig";
import Select from "../../../form/Select";
import Tabs from "../../../layout/Tabs";
import TabContent from "../../../layout/TabContent";
import Button from "../../../form/Button";
import Icon from "../../../form/Icon";
import classNames from "classnames";
import {Tooltip} from "react-tippy";
import {CurrencyFormatter, currencyMathString} from "../../../../utils/formatters";
import TextInput from "../../../form/TextInput";
import Portal from "../../../layout/Portal";
import Modal from "../../../layout/Modal";
import Collapse from "../../../layout/Collapse";
import {mathString} from "../../../../utils/math";

class MoneyTransferListExtend extends React.Component<any, any> {

    protected list: any;
    protected listHidden: any;

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
        this.listHidden && this.listHidden.refreshBackground();
    }

    refresh = () => {
        this.list && this.list.refresh();
        this.listHidden && this.listHidden.refresh();
    }

    render() {
        return (
            <Fragment>
                <MoneyTransferList
                    ref={(list) => this.list = list}
                    {...this.props}
                    exports={[]}
                    onLoadCompleted={() => {
                        this.listHidden && this.listHidden.refresh();
                    }}
                />
                <div className="hidden" style={{display: "none"}}>
                    <MoneyTransferList
                        ref={(list) => this.listHidden = list}
                        {...this.props}
                        exports={[]}
                        gridid={this.props.gridid + "hidden"}
                        pageSize={1}
                    />
                </div>
            </Fragment>
        );
    }
}


export default class MoneyRepositoryClosing extends React.Component<any, any> {

    state = {};

    refreshDom = {};

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (this.props.values[this.props.componentConfig.idfield] + "" !== "" + prevProps.values[this.props.componentConfig.idfield]) {
            const closings = [...(this.props.values.closings || []), ...(prevProps.values.closings || [])];
            const state = {};
            closings.map((closing, index) => {
                state["move." + index + ".items"] = [];
                state["move." + index + ".to"] = null;
            });
            this.setState(state);
        }
    }

    setFieldValue = (data) => {
        this.props.setFieldValue && this.props.setFieldValue("closings", data);
    }

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    moveItems = (e, index, componentConfig, moneyrepositoryConfig) => {
        e && e.preventDefault();
        this.props.processAction(async () => {
            await Promise.all(((this.state || {})["move." + index + ".items"] || []).map((item) => {
                return postData({
                    action: "MoneyTransfer.update",
                    [componentConfig.idfield]: item[[componentConfig.idfield]],
                    data: {
                        moneyrepository: (this.state || {})["move." + index + ".to"]
                    }
                });
            }));
            const closings = (this.props.values.closings || []);
            Object.keys(this.refreshDom).map((key) => {
                this.refreshDom[key] && this.refreshDom[key].refreshBackground();
            });
            await this.promisedSetState({["move." + index + ".to"]: null, ["move." + index + ".items"]: []});
            index = closings.map((closing, i) => (closing.moneyrepository[moneyrepositoryConfig.idfield] || closing.moneyrepository) + "" === "" + (this.state || {})["move." + index + ".to"] ? i : false).find((f) => f !== false);
            Object.keys(this.refreshDom).map((key) => {
                this.refreshDom[key] && this.refreshDom[key].refreshBackground();
            });
            return false;
        });
    }

    correctionData = (e, index, closing) => {
        closing = {...closing};
        closing.total = parseFloat(closing.invoice_total || "0") + parseFloat(closing.total || "0");
        const classes = calcClassName(closing);
        if (
            classes.current > 1 && closing.current !== undefined && closing.current !== null && closing.current !== ""
            &&
            classes.total > 1 && closing.total !== undefined && closing.total !== null && closing.total !== ""
        ) {
            // tárgyi és a slejfni megegyezik
            const amount = (closing.amount || 0) - closing.current;
            if (amount !== 0) {
                return {
                    moneyrepository: closing.moneyrepository.repository_id,
                    amount: Math.abs(amount),
                    direction: amount < 0 ? -1 : 1
                };
            }
        } else if
        (
            classes.amount > 1 && closing.amount !== undefined && closing.amount !== null && closing.amount !== ""
            &&
            classes.total > 1 && closing.total !== undefined && closing.total !== null && closing.total !== ""
        ) {
            // tényleges és a slejfni megegyezik
            const amount = closing.current - (closing.total || closing.amount);
            if (amount !== 0) {
                return {
                    moneyrepository: closing.moneyrepository.repository_id,
                    amount: Math.abs(amount),
                    direction: amount < 0 ? 1 : -1
                }
            }
        }
        return {amount: 0};
    }

    correctTransfers = async (e, index, closing) => {
        await this.props.processAction(async () => {
            const data = this.correctionData(e, index, closing);
            if (data.amount !== 0) {
                await saveComponent("MoneyTransfer", data);
            }
            Object.keys(this.refreshDom).map((key) => {
                this.refreshDom[key] && this.refreshDom[key].refreshBackground();
            });
            return false;
        });
    }

    render() {
        this.refreshDom = {};
        const closings = (this.props.values.closings || []);
        const moneyrepositories = closings.map((closing) => closing.moneyrepository);
        return (
            <ComponentConfig componentName="moneyrepository" componentConfigAs="moneyrepositoryConfig">
                {({moneyrepositoryConfig}) => <div className="row">
                    {closings.map((closing, index) => {
                        const values = {current: closing.current, amount: closing.amount, total: closing.total};
                        values.total = parseFloat(values.total);
                        if (closing.moneyrepository.component_type === "CreditCardTerminal") {
                            values.total += parseFloat(closing.invoice_total || "0");
                        }
                        values.total += parseFloat(closing.storno);
                        values.total = Math.round(values.total);
                        let correctionData = this.correctionData(null, index, closing);
                        const isCorrectable = correctionData.amount !== 0 && !this.props.values[this.props.componentConfig.idfield];
                        const selectable = !this.props.values[this.props.componentConfig.idfield];
                        return (
                            <div key={index} className={"col-md-" + Math.ceil(12 / closings.length)}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <Select
                                                {...this.props.getFieldProps("closings.moneyrepository")}
                                                label={false}
                                                name="moneyrepository"
                                                component="MoneyRepository"
                                                objectValue={false}
                                                labelKey="name"
                                                valueKey="repository_id"
                                                storeType="remote"
                                                value={closing.moneyrepository}
                                                disabled={true}
                                                saveChanges={(field, value) => {
                                                    const closing = JSON.parse(JSON.stringify(this.props.values.closings || []));
                                                    closing[index][field] = value;
                                                    this.setFieldValue(closing);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <Collapse button={<Button block={true} color="default">
                                                Tranzakciók <span className="caret"/>
                                            </Button>}>
                                                <div>
                                                    <ComponentConfig componentName="MoneyTransfer">
                                                        {(MoneyTransferConfigProps) => <Fragment>
                                                            <Tabs
                                                                theme="default"
                                                                currentTab="other"
                                                                renderAll={true}
                                                            >
                                                                <TabContent tabLabel="Tételek" tabName="other">
                                                                    <div className="row">
                                                                        <MoneyTransferList
                                                                            ref={(d) => this.refreshDom[index + "other"] = d}
                                                                            {...MoneyTransferConfigProps}
                                                                            exports={[]}
                                                                            gridid={"MoneyTransferListClosing" + index}
                                                                            showVisibleColumnFilter={false}
                                                                            className="p-small-table"
                                                                            filter={[{
                                                                                field: "invoice_count",
                                                                                value: 0
                                                                            }, {
                                                                                field: "moneyrepository",
                                                                                value: closing.moneyrepository[moneyrepositoryConfig.idfield]
                                                                            }, ...this.props.dateFilters]}
                                                                            onLoadCompleted={(response) => {
                                                                                this.props.loadFormData();
                                                                            }}
                                                                            selectionMode="multiple"
                                                                            onSelectionChange={(data) => selectable && this.setState({["move." + index + ".items"]: data.value})}
                                                                            selection={(this.state || {})["move." + index + ".items"] || []}
                                                                        />
                                                                    </div>
                                                                </TabContent>
                                                                <TabContent tabLabel="Számlás tételek" tabName="invoice">
                                                                    <div className="row">
                                                                        <MoneyTransferList
                                                                            ref={(d) => this.refreshDom[index + "invoice"] = d}
                                                                            {...MoneyTransferConfigProps}
                                                                            exports={[]}
                                                                            gridid={"MoneyTransferListClosing" + index}
                                                                            showVisibleColumnFilter={false}
                                                                            className="p-small-table"
                                                                            filter={[{
                                                                                field: "invoice_count",
                                                                                value: 0,
                                                                                operator: ">"
                                                                            }, {
                                                                                field: "moneyrepository",
                                                                                value: closing.moneyrepository[moneyrepositoryConfig.idfield]
                                                                            }, ...this.props.dateFilters]}
                                                                            onLoadCompleted={(response) => {
                                                                                this.props.loadFormData();
                                                                            }}
                                                                            selectionMode="multiple"
                                                                            onSelectionChange={(data) => selectable && this.setState({["move." + index + ".items"]: data.value})}
                                                                            selection={(this.state || {})["move." + index + ".items"] || []}
                                                                        />
                                                                    </div>
                                                                </TabContent>
                                                            </Tabs>
                                                            {!!this.state?.["move." + index + ".items"]?.length && <div className="form-group">
                                                                <div className="row form-row">
                                                                    <div className="col-md-6">
                                                                        <Select
                                                                            {...this.props.getFieldProps("closings.moneyrepository")}
                                                                            label={false}
                                                                            placeholder="Áthelyezés helye"
                                                                            name="moneyrepository"
                                                                            component="MoneyRepository"
                                                                            objectValue={false}
                                                                            labelKey="name"
                                                                            valueKey="repository_id"
                                                                            storeType="local"
                                                                            disabled={this.props.disabled || this.props.isLoading}
                                                                            options={[...moneyrepositories].filter((moneyrepository) => moneyrepository[moneyrepositoryConfig.idfield] + "" !== "" + closing.moneyrepository[moneyrepositoryConfig.idfield])}
                                                                            value={this.state?.["move." + index + ".to"]}
                                                                            saveChanges={(field, value) => this.setState({["move." + index + ".to"]: value})}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <Button
                                                                            block={true}
                                                                            disabled={this.props.disabled || this.props.isLoading || !this.state?.["move." + index + ".to"]}
                                                                            color="warning"
                                                                            onClick={(e) => this.moveItems(e, index, MoneyTransferConfigProps.componentConfig, moneyrepositoryConfig)}
                                                                        >
                                                                            Áthelyezés
                                                                        </Button>
                                                                    </div>
                                                                </div>
                                                            </div>}
                                                        </Fragment>}
                                                    </ComponentConfig>
                                                </div>
                                            </Collapse>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="form-group currency">
                                            <label className="control-label nowrap">
                                                Tárgyi egyenleg <Icon lib="fas" name="calculator" tooltip="A rendszerben lévő összeg" />
                                            </label>
                                            <div className={classNames({"input-group": isCorrectable})}>
                                                <Tooltip title={currencyMathString("#{c.open} + #{c.real_amount} + #{c.invoice_total_check} = #{=}", {c: closing})}>
                                                    <TextInput
                                                        name="current"
                                                        type="decimal"
                                                        value={parseFloat(closing.current || "0")}
                                                        formatter={CurrencyFormatter}
                                                        label={false}
                                                        {...this.props.getFieldProps("closings." + index + ".current")}
                                                        disabled={true}
                                                    />
                                                </Tooltip>
                                                {isCorrectable && <span className="input-group-btn">
                                                    <Portal>
                                                        <Modal
                                                            header="Korrekció"
                                                            ref={(modal) => this["modal" + index] = modal}
                                                            disabled={this.props.disabled || this.props.isLoading}
                                                            buttons={[
                                                                {
                                                                    text: "Mégse",
                                                                    props: {color: "default", disabled: this.props.isLoading},
                                                                    onClose: true,
                                                                    onClick: () => {
                                                                        this["modal" + index] && this["modal" + index].hide();
                                                                    }
                                                                },
                                                                {
                                                                    text: "Igen, ezt akarom",
                                                                    props: {color: "danger", disabled: this.props.isLoading},
                                                                    onClick: async (e) => {
                                                                        await this.correctTransfers(e, index, closing);
                                                                        this["modal" + index] && this["modal" + index].hide();
                                                                    }
                                                                }
                                                            ]}
                                                        >
                                                             <b>{correctionData.direction < 0 ? "Csökkenteni" : "Növelni"}</b> fogod <b>{CurrencyFormatter(correctionData.amount).props.children}</b>-al a tárgyi egyenleget! Biztos ezt akarod?
                                                        </Modal>
                                                    </Portal>
                                                    <Button
                                                        icon={{lib: "fas", name: "check-double"}}
                                                        tooltip={"Korrekció"}
                                                        color="warning"
                                                        onClick={() => this["modal" + index] && this["modal" + index].show()}
                                                        disabled={this.props.disabled || this.props.isLoading}
                                                    />
                                                </span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group currency">
                                            <TextInput
                                                name="amount"
                                                type="decimal"
                                                value={closing.amount}
                                                formatter={CurrencyFormatter}
                                                disabled={this.props.disabled || this.props.isLoading}
                                                disablePaste={true}
                                                label={<span className="nowrap">
                                                    Tényleges egyenleg <Icon lib="fas" name="money-bill-alt" tooltip="Tényleges pénzösszeg" />
                                                </span>}
                                                saveChanges={(field, value) => {
                                                    const closing = JSON.parse(JSON.stringify(this.props.values.closings || []));
                                                    closing[index][field] = value;
                                                    this.setFieldValue(closing);
                                                }}
                                                {...this.props.getFieldProps("closings." + index + ".amount")}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group currency">
                                                    <TextInput
                                                        name="total"
                                                        type="decimal"
                                                        value={closing.total}
                                                        formatter={CurrencyFormatter}
                                                        disabled={this.props.disabled || this.props.isLoading}
                                                        disablePaste={true}
                                                        label={<span className="nowrap">
                                                            Pénztárgép záró <Icon lib="fas" name="toilet-paper" tooltip="A pénztárgép által kiadott szalagon lévő összeg" />
                                                        </span>}
                                                        saveChanges={(field, value) => {
                                                            const closing = JSON.parse(JSON.stringify(this.props.values.closings || []));
                                                            closing[index][field] = value;
                                                            this.setFieldValue(closing);
                                                        }}
                                                        {...this.props.getFieldProps("closings." + index + ".total")}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group currency">
                                                    <TextInput
                                                        name="invoice_total"
                                                        type="decimal"
                                                        value={closing.invoice_total}
                                                        formatter={CurrencyFormatter}
                                                        disablePaste={true}
                                                        label={<span className="nowrap">
                                                            Számlás eladások <Icon lib="fas" name="file-invoice-dollar" tooltip={"Számlás eladások összege: " + CurrencyFormatter(closing.invoice_total_check).props.children} />
                                                        </span>}
                                                        disabled={this.props.disabled || this.props.isLoading || closing.moneyrepository.component_type === "CreditCardTerminal"}
                                                        saveChanges={(field, value) => {
                                                            const closing = JSON.parse(JSON.stringify(this.props.values.closings || []));
                                                            closing[index][field] = value;
                                                            this.setFieldValue(closing);
                                                        }}
                                                        {...this.props.getFieldProps("closings." + index + ".invoice_total")}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="form-group currency">
                                                    <TextInput
                                                        name="storno"
                                                        type="decimal"
                                                        value={closing.storno}
                                                        formatter={CurrencyFormatter}
                                                        disabled={this.props.disabled || this.props.isLoading}
                                                        disablePaste={true}
                                                        negative={true}
                                                        label={<span className="nowrap">
                                                            Bankkártyás sztornó <Icon lib="fas" name="band-aid" tooltip={closing.moneyrepository.component_type === "CashRepository" ? "Sztornózott bankkártyás nyugták összege" : "Sztornózott bankártyás nyugták összege negatív előjellel"} />
                                                        </span>}
                                                        saveChanges={(field, value) => {
                                                            const closing = JSON.parse(JSON.stringify(this.props.values.closings || []));
                                                            closing[index][field] = value;
                                                            this.setFieldValue(closing);
                                                        }}
                                                        {...this.props.getFieldProps("closings." + index + ".storno")}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>}
            </ComponentConfig>
        );
    }
}